import {
  SETTINGS,
  USER_LOGGED_IN_DETAILS,
  SIDEBAR_SCROLL_POSITION,
  ACTIVE_SIDEBAR_MENU,
  ACTIVE_SITE_DETAIL_TAB,
  ACTIVE_LEAVE_REQUESTS_TAB,
  ACTIVE_AR_REQUESTS_TAB,
  ACTIVE_OD_REQUESTS_TAB,
  ACTIVE_EMP_ONBOARD_TAB,
  NOTIFICATIONS,
  NOTIFICATION_COUNT,
  ACTIVE_PURCHASE_TAB,
  ACTIVE_PURCHASE_REQUEST_TAB,
  ACTIVE_PURCHASE_ORDER_TAB,
  ACTIVE_PT_AGAINST_PO_TAB,
  ACTIVE_PT_GENERAL_TAB,
  ACTIVE_PT_REIMB_TAB,
  ACTIVE_PAYMENT_ADVISORY_TAB,
  ACTIVE_SALARY_HEAD_TAB,
  UPDATE_FILTERS_STATES,
  ACTIVE_STOCK_OUT_TAB,
  ACTIVE_GRN_TAB,
  ACTIVE_PAYMENT_OVERVIEW_TAB,
  ACTIVE_ATTENDANCE_SUMMARY_TAB,
  UPDATE_DATE_FILTERS
} from "../types";

export const saveUserDetails = (payload) => {
  return {
    type: USER_LOGGED_IN_DETAILS,
    payload,
  };
};
export const saveNotifications = (payload) => {
  return {
    type: NOTIFICATIONS,
    payload,
  };
};
export const saveNotificationsCount = (payload) => {
  return {
    type: NOTIFICATION_COUNT,
    payload,
  };
};
export const saveSettings = (payload) => {
  return {
    type: SETTINGS,
    payload,
  };
};
export const saveSideBarScrollPosition = (payload) => {
  return {
    type: SIDEBAR_SCROLL_POSITION,
    payload,
  };
};
export const saveActiveSidebarTab = (payload) => {
  return {
    type: ACTIVE_SIDEBAR_MENU,
    payload,
  };
};
export const saveActiveSiteDetailTab = (payload) => {
  return {
    type: ACTIVE_SITE_DETAIL_TAB,
    payload,
  };
};
export const saveActiveLeaveRequestsTab = (payload) => {
  return {
    type: ACTIVE_LEAVE_REQUESTS_TAB,
    payload,
  };
};
export const saveActiveArRequestsTab = (payload) => {
  return {
    type: ACTIVE_AR_REQUESTS_TAB,
    payload,
  };
};
export const saveActiveOdRequestsTab = (payload) => {
  return {
    type: ACTIVE_OD_REQUESTS_TAB,
    payload,
  };
};
export const saveActiveEmpOnboardTab = (payload) => {
  return {
    type: ACTIVE_EMP_ONBOARD_TAB,
    payload,
  };
};
export const saveActivePurchaseTab = (payload) => {
  return {
    type: ACTIVE_PURCHASE_TAB,
    payload,
  };
};
export const saveActivePurchaseRequestTab = (payload) => {
  return {
    type: ACTIVE_PURCHASE_REQUEST_TAB,
    payload,
  };
};
export const saveActivePurchaseOrderTab = (payload) => {
  return {
    type: ACTIVE_PURCHASE_ORDER_TAB,
    payload,
  };
};
export const saveActivePtAgainstPoTab = (payload) => {
  return {
    type: ACTIVE_PT_AGAINST_PO_TAB,
    payload,
  };
};
export const saveActivePtGeneralTab = (payload) => {
  return {
    type: ACTIVE_PT_GENERAL_TAB,
    payload,
  };
};
export const saveActivePtReimbTab = (payload) => {
  return {
    type: ACTIVE_PT_REIMB_TAB,
    payload,
  };
};
export const saveActivePaymentAdvisoryTab = (payload) => {
  return {
    type: ACTIVE_PAYMENT_ADVISORY_TAB,
    payload,
  };
};
export const saveActiveGrnTab = (payload) => {
  return {
    type: ACTIVE_GRN_TAB,
    payload,
  };
};
export const saveActiveSalaryHeadTab = (payload) => {
  return {
    type: ACTIVE_SALARY_HEAD_TAB,
    payload,
  };
};
export const saveActiveStockOutTab = (payload) => {
  return {
    type: ACTIVE_STOCK_OUT_TAB,
    payload,
  };
};
export const saveActiveSummaryTab = (payload) => {
  return {
    type: ACTIVE_ATTENDANCE_SUMMARY_TAB,
    payload,
  };
};

export const updateDateFilter = (payload) => {
  return {
    type: UPDATE_DATE_FILTERS,
    payload,
  };
};

export const saveActivePaymentOverdueTab = (payload) => {
  return {
    type: ACTIVE_PAYMENT_OVERVIEW_TAB,
    payload,
  };
};

export const updateFiltersStates = (payload) => {
  return {
    type: UPDATE_FILTERS_STATES,
    payload,
  };
};

